import { Controller } from "@hotwired/stimulus"
import { requestPersistentStorage, vaultFailedCount, VAULT_WARNING_EVENT } from "../field_image_queue"

// Connects to data-controller="field-photo-vault" (the field layout body).
//
// Card #3995. Two jobs, neither of which can block a photo:
//
//   1. Ask the browser for persistent storage once per page load, and log what
//      it said, so a phone that refuses shows up by platform.
//   2. Show the plain warning when a photo could not be stored safely
//      ("This photo may not have saved...") and hide it again when no photo is
//      left that exists only in memory. field_image_queue announces each change
//      in that number on window. It warns; it never stops the camera.
//
// Targets:
//   banner  -- the hidden notice (field/shared/_photo_vault_banner)

// Shared across page loads (the body is replaced on every Turbo visit and so is
// this controller): a dismissed warning stays dismissed until another photo
// fails, and persistence is requested once per document.
let dismissed = false
let persistRequested = false

export default class extends Controller {
  static targets = ["banner"]

  connect() {
    if (!persistRequested) {
      persistRequested = true
      requestPersistentStorage().catch(() => {})
    }

    this._warnHandler = (event) => {
      const failed = event.detail?.failed ?? vaultFailedCount()
      // A photo newly failing re-opens a warning the tasker dismissed.
      if (failed > this._failed) dismissed = false
      this._failed = failed
      this._render()
    }
    window.addEventListener(VAULT_WARNING_EVENT, this._warnHandler)

    this._failed = vaultFailedCount()
    this._render()
  }

  disconnect() {
    window.removeEventListener(VAULT_WARNING_EVENT, this._warnHandler)
  }

  dismiss() {
    dismissed = true
    this._render()
  }

  // -- private --

  _render() {
    if (!this.hasBannerTarget) return
    const show = this._failed > 0 && !dismissed
    this.bannerTarget.classList.toggle("hidden", !show)
  }
}
